"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports["default"] = _default;